import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { NumericalFunctionEnum } from "../../enums/NumericalFunctionEnum";
import { DRCXAvailableObjectBase } from "./DRCXAvailableObjectBase";

export class DRCXAvailableTatColumn extends DRCXAvailableObjectBase<number> {
    public constructor(displayText: string, id: number, public dataType: DataTypeEnum, public summaryFunction?: NumericalFunctionEnum) {
        super(displayText, id);
    }
}
